import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "41",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M37.167 20.182c0 9.205-7.462 16.667-16.667 16.667S3.834 29.387 3.834 20.182c0-9.204 7.461-16.666 16.666-16.666s16.667 7.461 16.667 16.666",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M15.45 15.132a1.25 1.25 0 0 1 1.767 0l3.283 3.283 3.283-3.283A1.25 1.25 0 1 1 25.55 16.9l-3.283 3.282 3.283 3.283a1.25 1.25 0 0 1-1.768 1.768L20.5 21.95l-3.283 3.283a1.25 1.25 0 1 1-1.767-1.768l3.282-3.283L15.45 16.9a1.25 1.25 0 0 1 0-1.768"
    }, null, -1)
  ])))
}
export default { render: render }